@if (initialized) {
    @if (activeNavigationItem?.action === 'stepInfo') {
        <div class="scroll-table-container">
            @if (integrationTypeStepWidget) {
                <mvs-widget
                        [widgetData]="integrationTypeStepWidget">
                </mvs-widget>
            }
        </div>
    }

    @if (activeNavigationItem?.action === 'stepInputs') {
        <div class="scroll-table-container">
            @if (stepInputTableWidget) {
                <mvs-widget
                        [widgetData]="stepInputTableWidget"
                        (onObjectSelect)="handleStepInputSelect($event)">
                </mvs-widget>
            }
        </div>
    }

    @if (activeNavigationItem?.action === 'stepOutputs') {
        <div class="scroll-table-container">
            @if (stepOutputTableWidget) {
                <mvs-widget
                        [widgetData]="stepOutputTableWidget"
                        (onObjectSelect)="handleStepOutputSelect($event)">
                </mvs-widget>
            }
        </div>
    }

    @if (activeNavigationItem?.action === 'stepTransitions') {
        <div class="grid">
            <div class="col-6">
                <h4>Ausgehende Übergänge</h4>
                @if (stepTransitionFromTableWidget) {
                    <mvs-widget
                            [widgetData]="stepTransitionFromTableWidget"
                            (onObjectSelect)="handleStepTransitionSelect($event)">
                    </mvs-widget>
                }
            </div>
            <div class="col-6">
                <h4>Eingehende Übergänge</h4>
                @if (stepTransitionToTableWidget) {
                    <mvs-widget
                            [widgetData]="stepTransitionToTableWidget"
                            (onObjectSelect)="handleStepTransitionSelect($event)">
                    </mvs-widget>
                }
            </div>
        </div>
    }
}
